import { render, staticRenderFns } from "./AdminRolCard.vue?vue&type=template&id=937809b6&scoped=true&"
import script from "./AdminRolCard.ts?vue&type=script&lang=ts&"
export * from "./AdminRolCard.ts?vue&type=script&lang=ts&"
import style0 from "./AdminRolCard.scss?vue&type=style&index=0&id=937809b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937809b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VCol,VRow,VSwitch,VTextField})
